import { IApplication } from '../../../redux/types/ApplicationsTypes';
'../types/WithdrawalsTypes';
export interface ApplicationModel {
  id: string;
  merchant_order_id: string;
  merchant_client_id: string;
  date: string;
  bank: string;
  type: string;
  currency: string;
  amount: number;
  commission: number;
  course: number;
  final_amount: number;
  status: string;
  has_files?: boolean;
  comments: Record<number, string>;
  disputes: string[];
}

const mapApplications = (apps: IApplication[]): ApplicationModel[] =>
  apps.map((app) => ({
    id: app.id,
    merchant_order_id: app.merchant_order_id,
    merchant_client_id: app.merchant_client_id,
    date: new Date(app.date).toLocaleString(),
    bank: app.bank,
    type: app.type === 'deposit' ? 'Пополнение' : 'Выплата',
    currency: app.currency,
    amount: app.amount,
    commission: app.commission,
    course: app.course,
    final_amount: app.final_amount,
    status: app.status,
    has_files: app.has_files,
    comments: app.comments,
    disputes: app.disputes,
  }));

export default mapApplications;
